import {
  AzureControllerGetTenantGroupsApiArg,
  AzureControllerGetTenantGroupsApiResponse,
  AzureControllerGetTenantSubGroupsApiArg,
  AzureControllerGetTenantSubGroupsApiResponse,
  GSuiteControllerGetDomainGroupsApiArg,
  GSuiteControllerGetDomainGroupsApiResponse,
  GSuiteControllerGetDomainSubGroupsApiArg,
  GSuiteControllerGetDomainSubGroupsApiResponse,
  vsEntity2ApiInjected,
} from './vsEntity2ApiInjected';

type CursorSchema = { nextPageCursor: string | number | null };

export const vsEntity2ApiManualInjected = vsEntity2ApiInjected.injectEndpoints({
  endpoints: build => ({
    azureControllerGetTenantInfiniteGroups: build.infiniteQuery<
      AzureControllerGetTenantGroupsApiResponse,
      AzureControllerGetTenantGroupsApiArg,
      CursorSchema
    >({
      infiniteQueryOptions: {
        initialPageParam: { nextPageCursor: null },
        getNextPageParam(
          lastPage,
          allPages,
          lastPageParam,
          allPageParams,
          queryArg
        ) {
          if (lastPage.meta.next_cursor) {
            return { nextPageCursor: lastPage.meta.next_cursor };
          }
          return undefined;
        },
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/entity/api/v2/entity/user-sync/azure/tenants/${queryArg.tenantId}/groups`,
        params: {
          ...(pageParam.nextPageCursor
            ? { page_token: pageParam.nextPageCursor }
            : {}),
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    azureControllerGetTenantInfiniteSubGroups: build.infiniteQuery<
      AzureControllerGetTenantSubGroupsApiResponse,
      AzureControllerGetTenantSubGroupsApiArg,
      CursorSchema
    >({
      infiniteQueryOptions: {
        initialPageParam: { nextPageCursor: null },
        getNextPageParam(
          lastPage,
          allPages,
          lastPageParam,
          allPageParams,
          queryArg
        ) {
          if (lastPage.meta.next_cursor) {
            return { nextPageCursor: lastPage.meta.next_cursor };
          }
          return undefined;
        },
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/entity/api/v2/entity/user-sync/azure/tenants/${queryArg.tenantId}/groups/${queryArg.groupId}`,
        params: {
          ...(pageParam.nextPageCursor
            ? { page_token: pageParam.nextPageCursor }
            : {}),
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    gSuiteControllerGetDomainInfiniteGroups: build.infiniteQuery<
      GSuiteControllerGetDomainGroupsApiResponse,
      GSuiteControllerGetDomainGroupsApiArg,
      CursorSchema
    >({
      infiniteQueryOptions: {
        initialPageParam: { nextPageCursor: null },
        getNextPageParam(
          lastPage,
          allPages,
          lastPageParam,
          allPageParams,
          queryArg
        ) {
          if (lastPage.meta.next_cursor) {
            return { nextPageCursor: lastPage.meta.next_cursor };
          }
          return undefined;
        },
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/entity/api/v2/entity/user-sync/gsuite/domains/${queryArg.domainName}/groups`,
        params: {
          ...(pageParam.nextPageCursor
            ? { page_token: pageParam.nextPageCursor }
            : {}),
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    gSuiteControllerGetDomainInfiniteSubGroups: build.infiniteQuery<
      GSuiteControllerGetDomainSubGroupsApiResponse,
      GSuiteControllerGetDomainSubGroupsApiArg,
      CursorSchema
    >({
      infiniteQueryOptions: {
        initialPageParam: { nextPageCursor: null },
        getNextPageParam(
          lastPage,
          allPages,
          lastPageParam,
          allPageParams,
          queryArg
        ) {
          if (lastPage.meta.next_cursor) {
            return { nextPageCursor: lastPage.meta.next_cursor };
          }
          return undefined;
        },
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/entity/api/v2/entity/user-sync/gsuite/domains/${queryArg.domainName}/groups/${queryArg.groupId}`,
        params: {
          ...(pageParam.nextPageCursor
            ? { page_token: pageParam.nextPageCursor }
            : {}),
          page_size: queryArg.pageSize,
        },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});
